export enum EButtonKind {
  DANGER = "DANGER",
  NORMAL = "NORMAL",
  EDIT = "EDIT",
  SAVE = "SAVE",
}
